// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-card {
  background-color: #f8f9fa;
  transition: box-shadow 0.2s, opacity 0.3s;
}

.question-card:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.question-card.regenerating {
  opacity: 0.6;
  pointer-events: none;
}

.badge {
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 0.85em;
  font-weight: 500;
}

.badge-primary {
  background-color: #007bff;
  color: white;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.badge-success {
  background-color: #28a745;
}

.badge-warning {
  background-color: #ffc107;
  color: #000;
}

.badge-danger {
  background-color: #dc3545;
}

mat-spinner {
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/app/ai-test-generation/ai-test-generation.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".question-card {\n  background-color: #f8f9fa;\n  transition: box-shadow 0.2s, opacity 0.3s;\n}\n\n.question-card:hover {\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.question-card.regenerating {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.badge {\n  padding: 5px 10px;\n  border-radius: 3px;\n  font-size: 0.85em;\n  font-weight: 500;\n}\n\n.badge-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.badge-success {\n  background-color: #28a745;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #000;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n}\n\nmat-spinner {\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
